import { ChangeDetectionStrategy, Component } from '@angular/core'

import { provideFooterFromResolverRouteData } from 'app/core/cms/footer-data.token'
import { provideHeaderFromResolverRouteData } from 'app/core/cms/header-data.token'
import { provideLinksFromResolvedRouteData } from 'app/core/cms/links.token'
import { FooterComponent } from 'app/shared/footer/footer.component'
import { HeaderComponent } from 'app/shared/header/header.component'
import { RouterOutletDirective } from 'app/shared/router-outlet.directive'

@Component({
  selector: 'pai-site-wrapper',
  imports: [HeaderComponent, FooterComponent, RouterOutletDirective],
  templateUrl: './site-wrapper.component.html',
  styleUrl: './site-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideLinksFromResolvedRouteData(),
    provideHeaderFromResolverRouteData(),
    provideFooterFromResolverRouteData(),
  ],
})
export class SiteWrapperComponent {}
